import { render, staticRenderFns } from "./FieldsTable.vue?vue&type=template&id=7de64c0a&"
import script from "./FieldsTable.vue?vue&type=script&lang=ts&"
export * from "./FieldsTable.vue?vue&type=script&lang=ts&"
import style0 from "./FieldsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDataTable,VTextField})
